
// INDEXED DB CONFIG //
export const indexedDBs = {
    main: {
        dbName: 'PLLStatsDB',
        storeName: 'cache',
        dbVersion: 3,
        ttlMs: 1000 * 60 * 60 * 24 * 7 // 7 days
    }
}